import React, { useState, useEffect } from 'react'
import ThemeMaker from '../../components/thememaker'
import { Flex, Space, Table, Tag } from 'antd';
import { useHistory, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import jwt_decode from "jwt-decode";
import axios from 'axios';
import { config } from '../../utils/config';
import Checkbox from "@mui/material/Checkbox";
import { Select } from "antd";
import { FaEdit } from "react-icons/fa";
import { render } from 'react-dom';

export default function Serviceability() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const id = urlParams?.get('id');
    const location_id = urlParams?.get('warehouse_location_id');
    const Router = useHistory();
    const [showForm, setShowForm] = useState(false)
    const [allCities, setallcities] = useState([]);
    const [alldata, setalldata] = useState();
    let rawToken = sessionStorage.getItem("us_st_d");
    const options = allCities.map((city) => ({
        value: city.city_name,
        label: city.city_name,
    }));
    const [wareHouseType, setWareHouseType] = useState([])

    useEffect(() => {
        if (id && location_id) {

            getwarehouseFeature();
        }
    }, [id, location_id]);

    const getwarehouseFeature = async () => {
        try {
            const response = await axios({
                method: "POST",
                url: `${apiEndpoint}/get-seller-level-feature`,
                headers: {
                    "Content-Type": "application/json",
                    "X-Custom-Authorization": `Bearer ${rawToken}`
                },
                data: {
                    "warehouse_id": id,
                    "warehouse_location_id": location_id
                }


            });

            if (response.status === 200) {
                setWareHouseType(response.data.data?.map(
                    item => { return { label: item?.feature, id: item?.id } }
                ))
            }

        } catch (error) {
            console.log("Get Warehouse Time Error --->", error.response?.data || error.message);
        }
    };

    const seller_provider_id = decode?.data?.seller_data?.provider_id;
    const [selectedCities, setSelectedCities] = useState([]);
    const handleAutocompleteChange = (event, newSelectedCities) => {
        setSelectedCities(newSelectedCities);
    };
    const { baseNodeapiUrl, apiEndpoint } = config;
    const [update, setshowUpdate] = useState(false)
    var decode = rawToken ? jwt_decode(rawToken) : {};
    const columns = [
        {
            title: "Provider ID",
            dataIndex: "provider_id",
            key: "provider_id"
        },
        {
            title: " Service City",
            dataIndex: "service_city",
            key: "service_city"
        },
        {
            title: " Service Range(km)",
            dataIndex: "service_range",
            key: "service_range"
        },
        {
            title: " Service Type",
            dataIndex: "service_type",
            key: "service_type"
        },
        {
            title: " Warehouse Location ID",
            dataIndex: "warehouse_location_id",
            key: "warehouse_location_id"
        },
        {
            title: "Edit",
            key: "edit",
            render: () => (
                <FaEdit className='text-success'
                    style={{ cursor: "pointer" }}
                    onClick={() => setShowForm(true)}
                />
            )
        }
    ];
    const rawData = {
        fulfillment_type: "",
        payment_mode: "",
        fulfillment_method: "",
        delivery_fee: 0,
        packing_charge: 0,
        miscellaneous_charge: 0,
    }
    const rawErrorData = {
        fulfillment_type: false,
        payment_mode: false,
        fulfillment_method: false,
        delivery_fee: false,
        packing_charge: false,
        miscellaneous_charge: false,
        // seller_commision: false,
    }
    const [sellerData, setSellerData] = useState(rawData);
    const [sellerDataError, setSellerDataError] = useState(rawErrorData);
    const inputHandler = (e) => {
        setSellerData({ ...sellerData, [e.target.name]: e.target.value });
    }
    const errorHandler = (e) => {
        if (e.target.value) {
            setSellerDataError({ ...sellerDataError, [e.target.name]: "valid" });
        } else {
            setSellerDataError({ ...sellerDataError, [e.target.name]: true });
        }
    }

    const [feature, setFeature] = useState("");
    const [serviceData, setservicedata] = useState({
        service_type: "",
        service_range: "",
        service_city: ""
    });

    const onChangeHandler = (e) => {
        setservicedata((prev) => ({
            ...prev,
            [e.target.name]: e.target.value
        }));
    };

    const newFulfillmentCreateHandler = async () => {
        try {
            let payload = {
                feature: feature,
                warehouse_id: id,
                warehouse_location_id: location_id,
                service_type: serviceData.service_type,
                seller_level_feature_id: wareHouseType.find(item => item?.label === feature)?.id
            };

            if (serviceData.service_type === "hyperlocal") {
                payload = {
                    ...payload,
                    service_range: serviceData.service_range,
                    service_city: `std:${serviceData.service_city}`
                };
            } else if (serviceData.service_type === "intercity") {
                const cityNames = selectedCities.map((item) => item.city_name);
                payload = {
                    ...payload,
                    service_city: cityNames.join(",")
                };
            } else if (serviceData.service_type === "pan-india") {
                payload = {
                    ...payload
                };
            }

            const res = await axios({
                url: `${apiEndpoint}/warehouse-serviceability`,
                method: "POST",
                headers: {
                    "X-Custom-Authorization": `Bearer ${sessionStorage.getItem("us_st_d")}`
                },
                data: payload
            });

            if (res?.data) {
                toast.success("Serviceability Created Successfully");
                setShowForm(false)
                getServiceAbilityData()
            }

        } catch (err) {
            console.log(err);
            toast.error("Something went wrong, please try later!");
        }
    };

    useEffect(() => {
        getCities()
    }, [])

    useEffect(() => {
        getServiceAbilityData()
    }, [allCities])

    async function getCities() {
        try {
            const { data } = await axios({
                url: `${apiEndpoint}/getcity`,
                method: "GET",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem("us_st_d")}`
                }
            })

            if (data.status == 200) {
                setallcities(data.data)
            }
        } catch (err) {
            console.log(err)
        }


    }


    async function submitHandler(url) {
        let payload;

        if (serviceData.service_type === "intercity") {
            let selectedCityCodes = selectedCities.map((item) => item.city_code)
            payload = {
                ...serviceData, service_city: selectedCityCodes.toString(), service_range: ""
            }
        } else if (serviceData.service_type === "pan-india") {
            payload = {
                ...serviceData, service_city: "", service_range: ""
            }
        } else {
            payload = {
                ...serviceData
            }
        }

        try {
            const { data } = await axios({
                url: `${baseNodeapiUrl}/admin/api/${url}`,
                method: "POST",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem("us_st_d")}`
                },
                data: payload
            })
            if (data.message === "Serviceability inserted" || data.message === "Serviceability updated") {
                toast.success("Serviceability Updated")
            } else {
                toast.error("Error in data insertion")
            }
        } catch (err) {
            console.log(err)
            toast.error("Something went Wrong")
        }
    }

    async function getServiceAbilityData() {
        try {
            const response = await axios({
                url: `${apiEndpoint}/get-warehouse-serviceability`,
                method: "GET",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem("us_st_d")}`
                },
                params: {
                    warehouse_id: id,
                    warehouse_location_id: location_id
                }
            });

            const tableData = Array.isArray(response?.data?.data)
                ? response.data.data
                : [];
            setalldata(tableData);
            // setalldata(response?.data);
        } catch (error) {
            console.log(error);
        }
    }
    return (
        <ThemeMaker>
            <div className="row m-0 w-100 mt-1">
                <div className="col-md-12">
                    <div className=" mb-4">
                        <div>

                        </div>
                        <div className="card-body" style={{ height: "78vh", overflow: "scroll", scrollbarWidth: "none" }}>
                            <div className="row">
                                {!showForm && <div className='w-100'>
                                    <div className='d-flex justify-content-end'>
                                        <Tag color='geekblue' style={{ cursor: "pointer" }} onClick={() => setShowForm(true)}>
                                            Add Serviceability
                                        </Tag>
                                    </div>

                                    <div className="mt-2 ">
                                        <Table
                                            columns={columns}
                                            dataSource={alldata}
                                            rowKey="id"
                                            scroll={{ x: true }}
                                        />
                                    </div>

                                </div>}
                            </div>
                            {showForm && <div>
                                <div className='d-flex justify-content-end'>
                                    <Tag color='geekblue' style={{ cursor: "pointer" }} onClick={() => { setShowForm(false); setSellerData(rawData) }}>
                                        All Serviceability
                                    </Tag>
                                </div>
                                <div className="card-body" style={{ height: "80vh", overflow: "scroll", scrollbarWidth: "none" }}>
                                    <div className="row">
                                        <div className="col-md-6">

                                            <p className="genericlabel"> Warehouse Type<span className="text-danger" >*</span>
                                            </p>

                                            <div className='form-group'>
                                                <select className='form-control'
                                                    value={feature}
                                                    onChange={(e) => setFeature(e.target.value)}
                                                >
                                                    <option value="">Select types</option>


                                                    {
                                                        wareHouseType?.map(i => {
                                                            return <option value={i?.label}>{i?.label}</option>
                                                        })
                                                    }
                                                </select>
                                            </div>
                                        </div>
                                        {/* <div className="col-md-6">

                                            <select name="seller_level_feature" id="" className='form-control' value={product?.seller_level_feature}
                                                onChange={onChangeHandler}  >
                                                <option value="" disabled selected>Select type</option>
                                                <option value="inventory_less">Inventoryless</option>
                                                <option value="default">Defalut</option>
                                                <option value="both">Both</option>

                                            </select>
                                        </div> */}

                                        <div className="col-md-6">
                                            <p className="genericlabel"> Warehouse Id  </p>


                                            <div className="form-group">

                                                <div className='form-control bg-gray-200'>
                                                    {`${id}`}
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            <p className="genericlabel"> Warehouse Location Id  </p>


                                            <div className="form-group">

                                                <div className='form-control bg-gray-200'>
                                                    {`${location_id}`}
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-md-6">

                                            <p className="genericlabel"> Serviceability<span className="text-danger" >*</span>
                                            </p>

                                            <div className='form-group'>
                                                <select
                                                    name="service_type"
                                                    className="form-control"
                                                    value={serviceData.service_type}
                                                    onChange={onChangeHandler}
                                                >
                                                    <option value="">Select Serviceabilty</option>
                                                    <option value="hyperlocal">Hyper Local</option>
                                                    <option value="intercity">Intercity</option>
                                                    <option value="pan-india">Pan India</option>
                                                </select>
                                            </div>
                                            {
                                                serviceData.service_type === "hyperlocal" ? <div className='mt-3 col-md-12'>
                                                    <div className='col-md-10 row'>
                                                        <div className='col-md-4 p-0 m-0 mt-1'>
                                                            <label htmlFor="" className="genericlabel"> Area (in Km)</label>
                                                            <input
                                                                className="text-center form-control col-md-10"
                                                                type="text"
                                                                name="service_range"
                                                                value={serviceData.service_range}
                                                                onChange={onChangeHandler}
                                                            />
                                                        </div>

                                                        <div className='col-md-6 p-0 m-0 mt-1'>
                                                            <label htmlFor="" className="genericlabel">City</label>
                                                            <select
                                                                name="service_city"
                                                                value={serviceData.service_city}
                                                                onChange={onChangeHandler}
                                                                className="form-control col-md-12"
                                                            >
                                                                <option value="">Select City</option>

                                                                {allCities.map((item, index) => (
                                                                    <option key={index} value={item.city_code}>
                                                                        {item.city_name}
                                                                    </option>

                                                                ))}
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div> : null
                                            }
                                            {
                                                serviceData.service_type === "intercity" ? <div className='p-3 mt-3 w-100'>
                                                    <div style={{ maxWidth: "598px" }} >

                                                        <label htmlFor="" className="genericlabel">Cities</label> <br />
                                                        <Select
                                                            mode="multiple"
                                                            allowClear
                                                            style={{ width: "100%" }}
                                                            placeholder="Search and select cities"
                                                            value={selectedCities}
                                                            onChange={(value) => setSelectedCities(value)}
                                                            options={options}
                                                            showSearch
                                                            optionFilterProp="label"
                                                        />

                                                    </div>
                                                </div> : null
                                            }
                                        </div>

                                        <div className="col-md-12 d-flex justify-content-center mt-4">
                                            <button type="submit" className="btn btn-primary" style={{ width: "120px", borderRadius: "20px" }}
                                                onClick={newFulfillmentCreateHandler}>
                                                Submit
                                            </button>
                                        </div>
                                        {/* <small id="emailHelp" className="form-text text-muted">We'll never share your email with anyone else.</small> */}
                                    </div>

                                </div>
                            </div>}
                        </div>
                    </div>
                </div>
                {/* </div> */}
            </div>

        </ThemeMaker>
    )
}
